import React from "react";

// @material-ui/core components
import Box from "@material-ui/core/Box";
import FooterLinks from "./FooterLinks";

const Footer = () => {
  return (
    <Box component="footer" width="100%" padding="2.5rem 0">
      <FooterLinks/>
    </Box>
  );
};

export default Footer;
